
<template>
  <g>
    <path class="path" @mouseover="changeColor(i)" @mouseleave="changeColor(-1)" v-for="(sel, i) in scenario.select" :key="i" :d="makePath(scenario, sel, i)" fill="none" :stroke="makePathColor(i)" :opacity="strokeOpacity" :stroke-width="strokeWidth" @click="deleteNode(i)"/>
  </g>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ConnectPath',
  componentName: 'ConnectPath',
  computed: {
    ...mapState('chatbot', ['scenarioTable', 'chatbots', 'pathScenario']),
    ...mapState('auth', ['botstatus', 'user'])
  },
  props: ['scenario'],
  data () {
    return {
      strokeWidth: '5',
      strokeFill: [],
      strokeOpacity: 1.0,
      overIdx: -1
    }
  },
  mounted () {
    for (var i in this.scenario) {
      this.strokeFill.push('#6af')
    }
  },
  methods: {
    deleteNode (index) {
      var data = {
        scenario: this.scenario,
        index: index
      }
      this.$store.dispatch('chatbot/changeModalDeleteNode', data)
    },
    makePath (s, sel, index) {
      var nodeJson = {
        start: {
          x: 0,
          y: 0,
          name: ''
        },
        end: {
          x: 0,
          y: 0,
          name: ''
        }
      }
      var endIdx = -1
      this.scenarioTable.find(function (item, j) {
        if (item.beforenode === sel.next_node) {
          endIdx = j
          return j
        }
      })
      if (endIdx !== -1) {
        nodeJson.start.x = Number(s.beforenodeX) + 300
        if (s.status === 1 || s.status === 2 || (s.status >= 5 && s.status <= 8) || s.status === 10 || (s.status >= 13 && s.status <= 16) || (s.status >= 18 && s.status <= 21) || s.status === 100) {
          nodeJson.start.y = Number(s.beforenodeY) + 22.5
        } else if (s.status === 4) {
          if (index === 0) {
            nodeJson.start.y = Number(s.beforenodeY) + 22.5
          } else {
            nodeJson.start.y = Number(s.beforenodeY) + 62.5
          }
        } else {
          nodeJson.start.y = Number(s.beforenodeY) + 42.5 * (index + 2)
        }
        nodeJson.start.name = sel.next_node
        nodeJson.end.x = Number(this.scenarioTable[endIdx].beforenodeX) + 22.5
        nodeJson.end.y = Number(this.scenarioTable[endIdx].beforenodeY) + 22.5
        nodeJson.end.name = this.scenarioTable[endIdx].beforenode
        return this.curve(nodeJson)
      }
    },
    curve (node) {
      const qx1 = (node.start.x + node.end.x) / 2
      const qy1 = (node.start.y + node.end.y) / 2
      const qx2 = ((node.start.x + node.end.x) / 2 + node.start.x) / 2
      const amplitude = (node.end.y - node.start.y) / 4
      const qy2 = (node.start.y + node.end.y) / 2 + amplitude
      return 'M' + node.start.x + ',' + node.start.y + ' Q' + qx2 + ',' + qy2 + ' ' + qx1 + ',' + qy1 + ' T' + node.end.x + ',' + node.end.y
    },
    makePathColor (index) {
      if (this.pathScenario !== null) {
        for (var i in this.pathScenario.select) {
          for (var j in this.scenario.select) {
            if (this.pathScenario.select[i].next_node === this.scenario.select[j].next_node && this.pathScenario.beforenode === this.scenario.beforenode) return '#F00'
            else if (this.pathScenario.beforenode === this.scenario.select[j].next_node) return '#F00'
          }
        }
      }
      if (this.overIdx >= 0 && this.overIdx == index) return '#F00'
      else return '#6af'
    },
    changeColor (index) {
      this.overIdx = index
    }
  }
}
</script>

<style scoped>
.path {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/ConnectPathStore.vue